import { useEffect, useRef, useState } from "react";
import { Col, Container } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from 'yup'
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { failureAlert } from "../../CommonUtils/SweetAlerts";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";
import Ffcaunivpercentdrill from "./Ffcaunivpercentdrill";


export default function Ffcaunivpercent() {
    const hasFetchedData = useRef(false);
    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false)
    const [row, setRow] = useState([]);
    const dispatch = useDispatch();
    const validations = Yup.object({
        remarks: Yup.string().required(ERROR_MSG).nullable()
    })

    const formik = useFormik({
        initialValues: {
            remarks: ''
        },
        validationSchema: validations,
        onSubmit: () => {
            let payload = {
                empId: row?.original?.emp_id,
                remarks: formik.values.remarks
            }
            let url = config.url.API_URL + `DeleteEmployee`
            CommonAxiosPost(url, payload, dispatch).then((res) => {
                if (res.data.scode === '01') {
                    Swal.fire('Deleted Successfully', '', 'success').then((succ) => {
                        if (succ?.isConfirmed) {
                            window.location.reload()
                        }
                    })
                }
                else {
                    failureAlert("Failed to submit")

                }
            })
        }
    })
    function GetData() {
        let url = config.url.API_URL + `getcollegesreportffca`
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setData(res?.data?.data)

            }
        })
    }




    const [drilldown, Setdrilldown] = useState(0)
    const [ubcode, Setubcode] = useState('')
    const [start, Setstart] = useState('')
    const [end, Setend] = useState('')
    function navigatedrill(ubcode, start, end, data) {
        if (data == 0) {
            Swal.fire("NO DATA FOUND!", "", "info")
        } else {
            Setubcode(ubcode)
            Setdrilldown(1)
            Setstart(start)
            Setend(end)
        }
    }

    const Columns = [
        {
            Header: "Sl.no",
            accessor: (row, index) => index + 1,
            Footer: 'Total'
        },
        {
            Header: "Name of the University",
            accessor: "ub_name",
            Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row?.values?.ub_name ? row?.values?.ub_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Total Colleges",
            accessor: "tot_colleges", Footer: "tot_colleges",
            Cell: ({ row }) => <div style={{ textAlign: "right" }}> {row?.original?.tot_colleges}</div>
        },
        {
            Header: "Total Alloted",
            accessor: "tot_alloted", Footer: "tot_alloted",
            Cell: ({ row }) => <div style={{ textAlign: "right" }}>{row?.values?.tot_alloted}</div>
        },
        {
            Header: "Total Physical Verification",
            accessor: "tot_physical_verification", Footer: "tot_physical_verification",
            Cell: ({ row }) => <div style={{ textAlign: "right" }}>{row?.values?.tot_physical_verification}</div>
        },
        {
            Header: "Total Virtual Verification",
            accessor: "tot_virtual_verification", Footer: "tot_virtual_verification",
            Cell: ({ row }) => <div style={{ textAlign: "right" }}>{row?.values?.tot_virtual_verification}</div>
        },
        {
            Header: "100 Percentage",
            accessor: "per_100", Footer: "per_100",
            Cell: ({ row }) => <div style={{ textAlign: "right", color: 'blue' }} onClick={() => { navigatedrill(row?.original?.ub_code, "100", "100", row?.original?.per_100) }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigatedrill(row?.original?.ub_code, "100", "100", row?.original?.per_100)
                    }
                }}
            >{row?.values?.per_100}</div>
        },
        {
            Header: "76 to 99 Percentage",
            accessor: "per_76_99", Footer: "per_76_99",
            Cell: ({ row }) => <div style={{ textAlign: "right", color: 'blue' }} onClick={() => { navigatedrill(row?.original?.ub_code, "76", "99", row?.original?.per_76_99) }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigatedrill(row?.original?.ub_code, "76", "99", row?.original?.per_76_99)
                    }
                }}
            >{row?.values?.per_76_99}</div>
        },
        {
            Header: "51 to 75 Percentage",
            accessor: "per_51_75", Footer: "per_51_75",
            Cell: ({ row }) => <div style={{ textAlign: "right", color: 'blue' }} onClick={() => { navigatedrill(row?.original?.ub_code, "51", "75", row?.original?.per_51_75) }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigatedrill(row?.original?.ub_code, "51", "75", row?.original?.per_51_75)
                    }
                }}
            >{row?.values?.per_51_75}</div>
        },
        {
            Header: "26 to 50 Percentage",
            accessor: "per_26_50", Footer: "per_26_50",
            Cell: ({ row }) => <div style={{ textAlign: "right", color: 'blue' }} onClick={() => { navigatedrill(row?.original?.ub_code, "26", "50", row?.original?.per_26_50) }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigatedrill(row?.original?.ub_code, "26", "50", row?.original?.per_26_50)
                    }
                }}
            >{row?.values?.per_26_50}</div>

        },
        {
            Header: "1 to 25 Percentage",
            accessor: "per_1_25", Footer: "per_1_25",
            Cell: ({ row }) => <div style={{ textAlign: "right", color: 'blue' }} onClick={() => { navigatedrill(row?.original?.ub_code, "1", "25", row?.original?.per_1_25) }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigatedrill(row?.original?.ub_code, "1", "25", row?.original?.per_1_25)
                    }
                }}
            >{row?.values?.per_1_25}</div>
        },
        {
            Header: "FFCA Not Yet Started(NILL)",
            accessor: "per_0", Footer: "per_0",
            Cell: ({ row }) => <div style={{ textAlign: "right", color: 'blue' }} onClick={() => { navigatedrill(row?.original?.ub_code, "0", "0", row?.original?.per_0) }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigatedrill(row?.original?.ub_code, "0", "0", row?.original?.per_0)
                    }
                }}
            >{row?.values?.per_0}</div>
        }
    ]
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetData()
            hasFetchedData.current = true
        }
    }, [])

    const acYear = sessionStorage.getItem('ac_year');
    return (
        <>
            <CommonFormHeading heading="FFCA Completion Percentage Report" />
            {drilldown == 0 ? <>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex justify-content-between align-items-center">
                    <div className="inner-herbpage-service-title-sub pt-0"  >
                        <h1 className="m-0 p-0 pb-2">FFCA Completion Percentage Report, Ac-Year - {acYear}</h1>
                    </div>
                </Col>
                <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5 " style={{ backgroundColor: '#FAF7F0' }}  >
                    {/* {data && data?.length > 0 ? ( */}
                    <CommonReactTable data={data} columns={Columns} excelFlag={true} printFlag={true} filename="College Application Submission Percentage Report" headerName='' showFooter={"true"} />
                    {/* ) : (
                    <b className='text-error text-center'>No data Found</b>
                )} */}
                </Container>

            </> : <Ffcaunivpercentdrill ubcode={ubcode} start={start} end={end} Setdrilldown={Setdrilldown} />
            }        </>
    )
}
